import React, { useCallback } from 'react';
import { Transforms } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';

import HelptapEditor from '../../helpers';
import BaseElement from '../base';

function DataCollectionRowPage(props) {

  const element = props.element;
  const elementId = element.id;
  const editor = useSlateStatic();

  const handleClick = useCallback((event) => {

    const node = ReactEditor.toSlateNode(editor, event.target);
    const path = HelptapEditor.getClosestEditableNodePathFromPath(editor, ReactEditor.findPath(editor, node));

    // if text node is not selected, 
    // which are usually paths with 3 or more elements, 
    // no need to select it
    if (path === null || path.length <= 2) {
      return;
    }

    Transforms.deselect(editor);
    Transforms.select(editor, path);

  }, [editor]);

  function renderDataCollectionRowPage() {

    const { attributes, children } = props;

    const columnContainerAttributes = {
      ...attributes,
      suppressContentEditableWarning: true,
      contentEditable: false,
      onClick: handleClick,
      className: 'data-collection-wrapper'
    };
    const columnAttributes = {
      id: elementId
    };

    return (
      <div {...columnContainerAttributes}>
        <div {...columnAttributes}>
          {children}
        </div>
      </div>
    );
  }

  function renderMain() {
    const baseElementProperties = {
      ...props,
      customNodeControls: []
    };

    return (
      <BaseElement {...baseElementProperties}>
        {renderDataCollectionRowPage()}
      </BaseElement>
    );
  }

  return renderMain();
}

export default DataCollectionRowPage;